
import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const InsuranceClaimsStateWise = ({ filteredData, selectedState, selectedDistrict }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!filteredData || filteredData.length === 0) return;

    const myChart = echarts.init(chartRef.current);

    const uniqueStates = Array.from(
      new Set(
        filteredData.map((item) =>
          selectedState && !selectedDistrict
            ? item?.district_name
            : selectedDistrict
            ? item?.block_name
            : item?.state_name
        )
      )
    ).filter(Boolean); 


    const statuses = ["Lead Generated", "Claims Accepted","Claims Declined","Claims Approved","Claims Rejected","Claims Settled"];

    const seriesData = uniqueStates.map((state) => ({
      name: state,
      type: "bar",
      barGap: "0%", 
      barWidth: 30, 
      emphasis: { focus: "series" },
      data: statuses.map((status) => {
        const stateData = filteredData.find((item) =>
          selectedState && !selectedDistrict
            ? item.district_name === state
            : selectedDistrict
            ? item.block_name === state
            : item.state_name === state
        );

        if (!stateData) return 0;

        return status === "Lead Generated"
          ? stateData.lead_generated || 0     
          : status === "Claims Accepted"
          ? stateData.claim_accepted || 0
          : status === "Claims Declined"
          ? stateData.claim_declined || 0: status === "Claims Approved"
          ? stateData.claim_approved || 0: status === "Claims Rejected"
          ? stateData.claim_rejected || 0: status === "Claims Settled"
          ? stateData.claim_settled :0;
          
         
      }),
    }));

    // const option = {
    //   tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    //   legend: { data: uniqueStates },
    //   xAxis: {
    //     type: "category",
    //     data: statuses,
    //     axisLabel: { rotate: 30 }, 
    //   },
    //   yAxis: { type: "value" },
    //   series: seriesData,
    // };

    // myChart.setOption(option);
   const option = {
  tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
  legend: { data: uniqueStates },
  xAxis: {
    type: "category",
    data: statuses,
    axisLabel: { rotate: 30 },
  },
  yAxis: {
    type: "log",
    min: 1,     
    axisLabel: {
      formatter: (value) => Math.round(value),
    },
  },
  series: seriesData.map((series) => ({
    ...series,
    data: series.data.map((val) => (val === 0 ? 0 : val)), 
  })),
};

myChart.setOption(option);

    return () => myChart.dispose();
  }, [filteredData, selectedState, selectedDistrict]); 

  return <div ref={chartRef} style={{ width: "100%", height: "320px" }} />;
};

export default InsuranceClaimsStateWise;
